import { InferenceEventImage } from 'store/socket/listener'
import { InferenceImage } from 'type/Inference'

export class InferenceVideoStore {
  readonly id: number
  readonly src: string

  static fromJson(json: InferenceImage): InferenceVideoStore | undefined {
    if (!json.is_video || !json.video_url) return undefined
    const id = json.image_id
    const src = json.video_url
    return new InferenceVideoStore(id, src)
  }

  static fromEvent(event: InferenceEventImage): InferenceVideoStore | undefined {
    if (!event.isVideo) return undefined
    const id = event.int_id
    const src = event.url
    return new InferenceVideoStore(id, src)
  }

  constructor(id: number, src: string) {
    this.id = id
    this.src = src
  }
}
